import {
    Box,
    Center, Container,
    Image,
    Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay,
    Spinner,
    useDisclosure,
} from "@chakra-ui/react";
import React, {MutableRefObject} from "react";
import {QueryKey, useQuery} from "react-query";
import {Navigate} from "react-router-dom";

import {requestMultiMedia} from "../Api";
import {useTheme} from "../hooks/ThemeProvider";
import {Paths, ValidAudioFormats, ValidImageFormats} from "../model/Constants";
import {extractData} from "../Utils";
import AudioPlayer from "./AudioPlayer";
import Markdown from "./Markdown";

type ResourceProps = {
    resource: string;
    text?: string;
    compact?: boolean;
    timesPlayed?: MutableRefObject<number>;
    optionIds?: MutableRefObject<string[]>;
    subdirectory?: string;
    conditions?: string;
    onAudioPlayed?: (timesPlayed: number) => void;
};

const RenderResource = (props: ResourceProps) => {
  const theme = useTheme().theme;
    const { isOpen, onOpen, onClose } = useDisclosure()
    const publicSrc = (props.resource || "");//.replace(/\s/g, '');
    const extension = publicSrc.split('.').pop() || "";

    let sourceUrl = "";
    let sourceDir = "";
    let queryKey : QueryKey = ["public", publicSrc];

    if (ValidImageFormats.includes(extension)) {
        queryKey = ["public", "images", publicSrc];
        sourceDir = "images/";
    } else if (ValidAudioFormats.includes(extension)) {
        queryKey = ["public", "audio", publicSrc];
        sourceDir = "audio/";
    }

    const sourceQuery = useQuery(queryKey, () =>
        requestMultiMedia(publicSrc, extension, sourceDir, props.subdirectory || "").then(extractData),
      {retry: true}
    );

    if (sourceQuery.isError) {
        return <Navigate to={Paths.ERROR} />;
    } else if (!sourceQuery.data) {
        return (
            <Center height="200px">
                <Spinner />
            </Center>
        );
    } else {
        //Image maxBlockSize={"2xl"}
        if (!sourceUrl && sourceQuery.data.size > 0) {
            sourceUrl = URL.createObjectURL(sourceQuery.data);
        }
        if (sourceUrl && ValidImageFormats.includes(extension)) {
            return (
                <Box display='flex' alignItems='center' justifyContent='center'>
                    { props.text != null && <Markdown
                        content={props.text}
                        compact={props.compact}
                    /> }
                    <Container onClick={onOpen} justifyItems='center'
                               borderColor='black' border='solid'
                               cursor='zoom-in'>
                        <Image src={sourceUrl}
                           alt={publicSrc}
                           objectFit='contain'
                           maxHeight={"530px"}
                           draggable={false}
                           pointerEvents={"none"}
                        />
                    </Container>
                    <Modal  isOpen={isOpen} onClose={onClose} isCentered
                    scrollBehavior="inside"
                           size={"5xl"} >
                        <ModalOverlay />
                        <ModalContent
          filter= {'grayscale('+theme.IMG_GRAYSCALE+') contrast('+theme.IMG_CONTRAST+')'}
                   >
                            <ModalCloseButton />
                            <ModalBody style={{
                                 justifyItems:'center',
                            }}>
                                <Image src={sourceUrl}
                                       alt={publicSrc}
                                       maxWidth='3xl'
                                       maxHeight='800px'
                                       minWidth='3xl'
                                       objectFit='contain'
                                       draggable={false}
                                       pointerEvents={"none"}
                                />
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                </Box>
            )
        } else if (sourceUrl && ValidAudioFormats.includes(extension)) {

              let maxNumberOfReproductions = 2;
              if (props.conditions){
                  const pattern = /AudioTimes(\d+)/g;
                  const patternExists = pattern.exec(props.conditions);
                  if (patternExists !== null && patternExists[1] !== null) {
                    const numberPattern = /(\d+)/g;
                    const numberExists = numberPattern.exec(patternExists[1]);
                    if (numberExists !== null && numberExists[1] !== null)
                        maxNumberOfReproductions = Number(numberExists[1]);
                  }
              }
            return (
                <AudioPlayer
                    sourceUrl={sourceUrl}
                    timesPlayed={props.timesPlayed}
                    onAudioPlayed={props.onAudioPlayed}
                    maxNumberOfReproductions={maxNumberOfReproductions}
                />
            )
        } else {
            return (
                <Markdown
                    content={props.text + " " + props.resource}
                    compact={props.compact}
                />
            )
        }
    }
}


export default RenderResource;
